/*
 * Status Monitor
*/

export const GET_CUSTOMER_INCIDENTS = 'GET_CUSTOMER_INCIDENTS';
export const GET_CUSTOMER_INCIDENTS_SUCCESS = 'GET_CUSTOMER_INCIDENTS_SUCCESS';
export const GET_CUSTOMER_INCIDENTS_ERROR = 'GET_CUSTOMER_INCIDENTS_ERROR';

export const CREATE_CUSTOMER_INCIDENTS = "CREATE_CUSTOMER_INCIDENTS"
export const CREATE_CUSTOMER_INCIDENTS_SUCCESS = "CREATE_CUSTOMER_INCIDENTS_SUCCESS"
export const CREATE_CUSTOMER_INCIDENTS_ERROR = "CREATE_CUSTOMER_INCIDENTS_ERROR"

export const UPDATE_CUSTOMER_INCIDENTS = "UPDATE_CUSTOMER_INCIDENTS"
export const UPDATE_CUSTOMER_INCIDENTS_SUCCESS = "UPDATE_CUSTOMER_INCIDENTS_SUCCESS"
export const UPDATE_CUSTOMER_INCIDENTS_ERROR = "UPDATE_CUSTOMER_INCIDENTS_ERROR"


export const GET_TIMEFRAME_REPORTING_DATA = 'GET_TIMEFRAME_REPORTING_DATA';
export const GET_TIMEFRAME_REPORTING_DATA_SUCCESS = 'GET_TIMEFRAME_REPORTING_DATA_SUCCESS';
export const GET_TIMEFRAME_REPORTING_DATA_ERROR = 'GET_TIMEFRAME_REPORTING_DATA_ERROR';
